import React from 'react';
import UserDetailTable from '../components/users/UserDetailTable';

const Users = () => {
  return (
    <div className="space-y-5">
      <UserDetailTable />
    </div>
  );
};

export default Users;
